import React, { useState } from 'react';
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Box,
  Typography,
  Modal,
  CircularProgress,
} from '@mui/material';
import { exchangeRates } from 'src/utils/const';
import { callApi } from 'src/core/callApi';

const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2021;
  const years: number[] = [];
  for (let i = currentYear; i >= startYear; i--) {
    years.push(i);
  }
  return years;
};

const generateMonthOptions = () => {
  return [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];
};

const DataExportForm = ({}) => {
  const [marketID, setmarketID] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [startYear, setStartYear] = useState('');
  const [startMonth, setStartMonth] = useState('');
  const [endYear, setEndYear] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [timeGranularity, setTimeGranularity] = useState('');
  const [lastAvailable, setLastAvailable] = useState('');
  const [currency, setCurrency] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exportConfig, setExportConfig] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const currencies = Object.keys(exchangeRates);

  const handleOpenModal = () => {
    const startMonthFormatted = `${startYear}-${startMonth}`;
    const endMonthFormatted = `${endYear}-${endMonth}`;

    const config = {
      operation: 'trigger',
      marketID,
      countryCode,
      startMonth: startMonthFormatted,
      endMonth: endMonthFormatted,
      timeGranularity,
      lastAvailable,
      currency,
    };

    setExportConfig(config);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmExport = async () => {
    setIsModalOpen(false);
    setLoading(true);
    const url = 'https://l8q69lzrxc.execute-api.us-east-2.amazonaws.com/default/dataExportHandler';
    const config = {
      queryParams: exportConfig,
    };
    const res = await callApi(url, config, false);
    console.log('res:', res);
    setLoading(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6">Custom Data Export Form</Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Market ID"
            value={marketID}
            onChange={e => setmarketID(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Country Code"
            value={countryCode}
            onChange={e => setCountryCode(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                select
                label="Start Year"
                value={startYear}
                onChange={e => setStartYear(e.target.value)}
                fullWidth
              >
                {generateYearOptions().map(year => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="Start Month"
                value={startMonth}
                onChange={e => setStartMonth(e.target.value)}
                fullWidth
              >
                {generateMonthOptions().map(month => (
                  <MenuItem key={month.value} value={month.value}>
                    {month.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                select
                label="End Year"
                value={endYear}
                onChange={e => setEndYear(e.target.value)}
                fullWidth
              >
                {generateYearOptions().map(year => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="End Month"
                value={endMonth}
                onChange={e => setEndMonth(e.target.value)}
                fullWidth
              >
                {generateMonthOptions().map(month => (
                  <MenuItem key={month.value} value={month.value}>
                    {month.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label="Time Granularity"
            value={timeGranularity}
            onChange={e => setTimeGranularity(e.target.value)}
            fullWidth
          >
            <MenuItem value="monthly">Monthly</MenuItem>
            <MenuItem value="yearly">Yearly</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label="Last Available"
            value={lastAvailable}
            onChange={e => setLastAvailable(e.target.value)}
            fullWidth
          >
            <MenuItem value="all-time">All-time</MenuItem>
            <MenuItem value="180">Last 180 days</MenuItem>
            <MenuItem value="365">Last 365 days</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label="Currency"
            value={currency}
            onChange={e => setCurrency(e.target.value)}
            fullWidth
          >
            {currencies.map(currency => (
              <MenuItem value={currency}>{currency}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={handleOpenModal}
            fullWidth
            sx={{
              padding: '8px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 100,
              color: 'white',
            }}
            disabled={loading == true}
          >
            {loading ? 'Starting export...' : 'Start Export'}
            {loading && <CircularProgress />}
          </Button>
        </Grid>
      </Grid>

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography id="confirmation-modal-title" variant="h6" component="h2">
            Confirm Export
          </Typography>
          <Typography id="confirmation-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to export data with the following configuration?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Market ID:</span> {exportConfig?.marketID}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Country Code:</span> {exportConfig?.countryCode}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Start Month:</span> {exportConfig?.startMonth}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>End Month:</span> {exportConfig?.endMonth}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Time Granularity:</span>{' '}
              {exportConfig?.timeGranularity}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Last Available:</span>{' '}
              {exportConfig?.lastAvailable}
            </Typography>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>Currency:</span> {exportConfig?.currency}
            </Typography>
          </Box>
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
            <Button variant="outlined" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleConfirmExport}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DataExportForm;
